import { MutationTree } from 'vuex';
import { InquiryFormState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<InquiryFormState> = {
	SET_INQUIRY_FORM(state, form: InquiryForm): void {
		Vue.set(state, 'inquiryForm', form);
	},

	SET_INQUIRY_FORM_REQUESTS(state, requests: InquiryFormRequest[]): void {
		if (state.selectedInquiryFormRequest) {
			const index = requests.findIndex((r) => r.id === state.selectedInquiryFormRequest!.id);
			if (index !== -1) {
				requests[index] = { ...requests[index], ...state.selectedInquiryFormRequest };
			}
		}
		Vue.set(state, 'inquiryFormRequests', requests);
	},

	UPDATE_INQUIRY_FORM_REQUEST(state, request: InquiryFormRequest): void {
		const requestIndex = state.inquiryFormRequests.findIndex((r) => request.id === r.id);
		if (requestIndex !== -1) {
			Vue.set(state.inquiryFormRequests, requestIndex, request);
		}
	},

	SET_SELECTED_INQUIRY_FORM_REQUEST(state, request: InquiryFormRequest | null): void {
		Vue.set(state, 'selectedInquiryFormRequest', request);
	},

	SET_INQUIRY_FORM_FILTERS(state, filters: InquiryFormFilters): void {
		Vue.set(state, 'filters', filters);
	},

	SET_CURRENT_PAGE(state, page: number): void {
		state.currentPage = page;
	},

	SET_TOTAL_PAGES(state, totalPages: number): void {
		state.totalPages = totalPages;
	}
};
